import type { ThemeItem } from '../../../core/domain'

export const SOCCER_ITEMS: ThemeItem[] = [
  { name: 'Piet Kraak', imageUrl: null, fact: 'Dutch footballer and football coach (1921-1984)' },
  {
    name: 'František Plánička',
    imageUrl: null,
    fact: 'Czech association football player (1904-1996)'
  },
  {
    name: 'Lionel Messi',
    imageUrl: null,
    fact: 'Argentine association football player (born 1987)'
  },
  { name: 'Alessandro Del Piero', imageUrl: null, fact: 'Italian association football player' },
  {
    name: 'Adriaan Paulen',
    imageUrl: null,
    fact: 'Dutch athlete and president of the IAAF (1902-1985)'
  },
  {
    name: 'Zinedine Zidane',
    imageUrl: null,
    fact: 'French professional football manager and former player'
  },
  { name: 'Laurent Blanc', imageUrl: null, fact: 'French football manager (born 1965)' },
  { name: 'Corentin Martins', imageUrl: null, fact: 'French footballer and manager (born 1969)' },
  { name: 'Sabri Lamouchi', imageUrl: null, fact: 'French football manager (born 1971)' },
  { name: 'Jürgen Locadia', imageUrl: null, fact: 'Curaçaoan footballer' },
  { name: 'Memphis Depay', imageUrl: null, fact: 'Dutch association football player (born 1994)' },
  { name: 'Hugo Lloris', imageUrl: null, fact: 'French footballer (born 1986)' },
  { name: 'Mathieu Debuchy', imageUrl: null, fact: 'French footballer (born 1985)' },
  { name: 'Adil Rami', imageUrl: null, fact: 'French footballer (born 1985)' },
  { name: 'Yohan Cabaye', imageUrl: null, fact: 'French footballer (born 1986)' },
  { name: 'Olivier Giroud', imageUrl: null, fact: 'French footballer (born 1986)' },
  { name: 'Karim Benzema', imageUrl: null, fact: 'French footballer (born 1987)' },
  { name: 'Florent Malouda', imageUrl: null, fact: 'French footballer (born 1980)' },
  { name: 'Laurent Koscielny', imageUrl: null, fact: 'French footballer (born 1985)' },
  { name: 'Patrice Evra', imageUrl: null, fact: 'French footballer (born 1981)' },
  { name: 'Philippe Mexès', imageUrl: null, fact: 'French footballer (born 1982)' },
  { name: 'Franck Ribéry', imageUrl: null, fact: 'French footballer (born 1983)' },
  { name: 'Mathieu Valbuena', imageUrl: null, fact: 'French footballer (born 1984)' },
  { name: 'Samir Nasri', imageUrl: null, fact: 'French footballer (born 1987)' },
  { name: 'Blaise Matuidi', imageUrl: null, fact: 'French footballer (born 1987)' },
  { name: 'Anthony Réveillère', imageUrl: null, fact: 'French footballer (born 1979)' },
  { name: 'Jérémy Ménez', imageUrl: null, fact: 'French association football player' },
  { name: 'Steve Mandanda', imageUrl: null, fact: 'French footballer (born 1985)' },
  { name: "Yann M'Vila", imageUrl: null, fact: 'French association football player (born 1990)' },
  { name: 'Alou Diarra', imageUrl: null, fact: 'French football manager (born 1981)' },
  { name: 'Marvin Martin', imageUrl: null, fact: 'French footballer (born 1988)' },
  { name: 'Hatem Ben Arfa', imageUrl: null, fact: 'French footballer (born 1987)' },
  { name: 'Gaël Clichy', imageUrl: null, fact: 'French footballer (born 1985)' },
  { name: 'Cédric Carrasso', imageUrl: null, fact: 'French footballer (born 1981)' },
  { name: 'Sidney Govou', imageUrl: null, fact: 'French footballer (born 1979)' },
  { name: 'Eric Abidal', imageUrl: null, fact: 'French footballer (born 1979)' },
  { name: 'Djibril Cissé', imageUrl: null, fact: 'French footballer (born 1981)' },
  { name: 'William Gallas', imageUrl: null, fact: 'French footballer (born 1977)' },
  { name: 'Bacary Sagna', imageUrl: null, fact: 'French footballer (born 1983)' },
  { name: 'Nicolas Anelka', imageUrl: null, fact: 'French football manager (born 1979)' },
  { name: 'André-Pierre Gignac', imageUrl: null, fact: 'French footballer (born 1985)' },
  { name: 'Sébastien Squillaci', imageUrl: null, fact: 'French footballer (born 1980)' },
  { name: 'Abou Diaby', imageUrl: null, fact: 'French footballer (born 1986)' },
  { name: 'Jérémy Toulalan', imageUrl: null, fact: 'French footballer (born 1983)' },
  {
    name: 'Robin van Persie',
    imageUrl: null,
    fact: 'Dutch association football player and manager'
  },
  {
    name: 'Dennis Lawrence',
    imageUrl: null,
    fact: 'Trinidad and Tobago association football player and manager'
  },
  {
    name: 'Franciszek Smuda',
    imageUrl: null,
    fact: 'Polish football player and manager (1948–2024)'
  },
  { name: 'T-killah', imageUrl: null, fact: 'Russian singer and rapper' },
  { name: 'Bernard Lacombe', imageUrl: null, fact: 'French football manager (1952–2025)' },
  { name: 'Fleury Di Nallo', imageUrl: null, fact: 'French former association football player' },
  { name: 'Serge Chiesa', imageUrl: null, fact: 'French footballer (born 1950)' },
  { name: 'Jean-Michel Aulas', imageUrl: null, fact: 'French businessman (born 1949)' },
  {
    name: 'Michel Platini',
    imageUrl: null,
    fact: 'French football player, manager and executive (born 1955)'
  },
  {
    name: 'Franz Beckenbauer',
    imageUrl: null,
    fact: 'German sports official and association football player (1945–2024)'
  },
  { name: 'Joachim Löw', imageUrl: null, fact: 'German football player and manager' },
  { name: 'Sean Connery', imageUrl: null, fact: 'Scottish actor (1930–2020)' },
  { name: 'Raúl Albiol', imageUrl: null, fact: 'Spanish association football player' },
  { name: 'Gianfranco Zola', imageUrl: null, fact: 'Italian footballer and manager' },
  {
    name: 'Graham Taylor',
    imageUrl: null,
    fact: 'English association football player and manager (1944-2017)'
  },
  { name: 'Kelly Smith', imageUrl: null, fact: 'English footballer (born 1978)' },
  { name: 'Francisco Varallo', imageUrl: null, fact: 'Argentine footballer (1910-2010)' },
  { name: 'David Beckham', imageUrl: null, fact: 'English footballer (born 1975)' },
  { name: 'Ryan Giggs', imageUrl: null, fact: 'Welsh association football player and coach' },
  {
    name: 'John Barnes',
    imageUrl: null,
    fact: 'association football player and manager (born 1963)'
  },
  { name: 'Tommy Mooney', imageUrl: null, fact: 'English association football player (born 1971)' },
  {
    name: 'Rob Page',
    imageUrl: null,
    fact: 'Welsh association football player and coach (born 1974)'
  },
  { name: 'Heiðar Helguson', imageUrl: null, fact: 'Icelandic association football player' },
  {
    name: 'Freddie Ljungberg',
    imageUrl: null,
    fact: 'Swedish association football player and manager'
  },
  { name: 'Danny Graham', imageUrl: null, fact: 'English association football player' },
  { name: 'Adrian Mariappa', imageUrl: null, fact: 'Jamaican footballer (born 1986)' },
  {
    name: 'Tom Cleverley',
    imageUrl: null,
    fact: 'English association football player (born 1989)'
  },
  {
    name: 'Tommy Smith',
    imageUrl: null,
    fact: 'English association football player, born 1980 in Hemel Hempstead'
  },
  { name: 'Ben Foster', imageUrl: null, fact: 'English association football player (born 1983)' },
  { name: 'Marlon King', imageUrl: null, fact: 'Jamaican-English footballer (born 1980)' },
  { name: 'Gavin Mahon', imageUrl: null, fact: 'English footballer (born 1977)' },
  { name: 'Marcus Gayle', imageUrl: null, fact: 'Jamaican footballer and manager (born 1970)' },
  {
    name: 'Alec Chamberlain',
    imageUrl: null,
    fact: 'English association football player and goalkeeping coach (born 1964)'
  },
  { name: 'David James', imageUrl: null, fact: 'English association football player' },
  { name: 'Sean Dyche', imageUrl: null, fact: 'English football player and manager' },
  {
    name: 'Ray Lewington',
    imageUrl: null,
    fact: 'English association football player, coach and manager (born 1956)'
  },
  { name: 'Kenny Jackett', imageUrl: null, fact: 'Welsh association football player, manager' },
  { name: 'Ashley Young', imageUrl: null, fact: 'English association football player' },
  {
    name: 'Marvin Sordell',
    imageUrl: null,
    fact: 'English association football player (born 1991)'
  },
  {
    name: 'Lloyd Doyley',
    imageUrl: null,
    fact: 'Professional association football player for Watford (born 1982)'
  },
  {
    name: 'Aidy Boothroyd',
    imageUrl: null,
    fact: 'English association football player, coach and manager (born 1971)'
  },
  { name: 'Scott Loach', imageUrl: null, fact: 'English association football player (born 1988)' },
  {
    name: 'Nyron Nosworthy',
    imageUrl: null,
    fact: 'Jamaican association football player (born 1980)'
  },
  { name: 'Fitz Hall', imageUrl: null, fact: 'English association football player (born 1980)' },
  {
    name: 'Fernando Forestieri',
    imageUrl: null,
    fact: 'Italian-Argentine professional association football player'
  },
  { name: 'Manuel Almunia', imageUrl: null, fact: 'Spanish association football player' },
  {
    name: 'Lee Hodson',
    imageUrl: null,
    fact: 'Northern Ireland association football player (born 1991)'
  },
  {
    name: 'John Eustace',
    imageUrl: null,
    fact: 'English professional association football player (born 1979)'
  },
  { name: 'Mark Yeates', imageUrl: null, fact: 'Irish association football player' },
  {
    name: 'Jonathan Hogg',
    imageUrl: null,
    fact: 'English association football player (born 1988)'
  },
  { name: 'Troy Deeney', imageUrl: null, fact: 'English association football player (born 1988)' },
  {
    name: 'Chris Iwelumo',
    imageUrl: null,
    fact: 'Scottish association football player (born 1978)'
  },
  { name: 'Steve Leo Beleck', imageUrl: null, fact: 'Cameroonian association football striker' },
  { name: 'Stephen McGinn', imageUrl: null, fact: 'Scottish footballer (born 1988)' },
  {
    name: 'Sean Murray',
    imageUrl: null,
    fact: 'Irish association football midfielder (born 1993)'
  },
  { name: 'Matěj Vydra', imageUrl: null, fact: 'Czech association football player' },
  { name: 'Ikechi Anya', imageUrl: null, fact: 'Scottish footballer (born 1988)' },
  { name: 'Almen Abdi', imageUrl: null, fact: 'Swiss association football midfielder' },
  { name: 'Jonathan Bond', imageUrl: null, fact: 'English association football player' },
  { name: 'Tommie Hoban', imageUrl: null, fact: 'association football player (born 1994)' },
  { name: 'Alex Geijo', imageUrl: null, fact: 'Spanish Swiss-born professional footballer' },
  { name: 'Cristian Battocchio', imageUrl: null, fact: 'Italian association football player' },
  {
    name: 'Nathaniel Chalobah',
    imageUrl: null,
    fact: 'English association football player (born 1994)'
  },
  {
    name: 'Jean-Alain Fanchone',
    imageUrl: null,
    fact: 'French professional association football player'
  },
  { name: 'Rachel Brown', imageUrl: null, fact: 'English footballer (born 1980)' },
  {
    name: 'Hope Powell',
    imageUrl: null,
    fact: 'English association football player and manager (born 1966)'
  },
  { name: 'Karen Bardsley', imageUrl: null, fact: 'American-English footballer' },
  { name: 'Casey Stoney', imageUrl: null, fact: 'English association football player (born 1982)' },
  { name: 'Rachel Unitt', imageUrl: null, fact: 'English association football player' },
  {
    name: 'Steph Houghton',
    imageUrl: null,
    fact: 'English association football player (born 1988)'
  },
  {
    name: 'Laura Bassett',
    imageUrl: null,
    fact: 'English association football player (born 1983)'
  },
  { name: 'Dunia Susi', imageUrl: null, fact: 'English association football player (born 1987)' },
  {
    name: 'Claire Rafferty',
    imageUrl: null,
    fact: 'English association football player (born 1989)'
  },
  {
    name: 'Rachel Yankey',
    imageUrl: null,
    fact: 'English association football player (born 1979)'
  },
  {
    name: 'Fara Williams',
    imageUrl: null,
    fact: 'English association football player (born 1984)'
  },
  { name: 'Karen Carney', imageUrl: null, fact: 'English association football player (born 1987)' },
  { name: 'Jill Scott', imageUrl: null, fact: 'English association football player' },
  { name: 'Anita Asante', imageUrl: null, fact: 'English footballer (born 1985)' },
  { name: 'Tunay Torun', imageUrl: null, fact: 'Turkish association football player (born 1990)' },
  { name: 'Mehmet Ekici', imageUrl: null, fact: 'Turkish association football player (born 1990)' },
  { name: 'Werner Kohlmeyer', imageUrl: null, fact: 'German footballer (1924-1974)' },
  { name: 'Fredi Bobic', imageUrl: null, fact: 'German football executive and former player' },
  { name: 'Markus Babbel', imageUrl: null, fact: 'German association football player and manager' },
  { name: 'Julian Schieber', imageUrl: null, fact: 'German football player' },
  { name: 'Sami Allagui', imageUrl: null, fact: 'Tunisian association football player' },
  { name: 'Armin Veh', imageUrl: null, fact: 'German association football player and manager' },
  { name: 'Mirko Slomka', imageUrl: null, fact: 'German association football player and manager' },
  { name: 'Gökhan Töre', imageUrl: null, fact: 'Turkish association football player (born 1992)' },
  {
    name: 'Sofian Chahed',
    imageUrl: null,
    fact: 'German-Tunisian association football player (born 1983)'
  },
  { name: 'Takashi Inui', imageUrl: null, fact: 'Japanese association football player' },
  { name: 'Änis Ben-Hatira', imageUrl: null, fact: 'Tunisian association football player' },
  { name: 'Hansi Müller', imageUrl: null, fact: 'German association football player' },
  { name: 'Christian Abbiati', imageUrl: null, fact: 'Italian association football player' },
  {
    name: 'Angelo Alessio',
    imageUrl: null,
    fact: 'Italian association football player and manager'
  },
  { name: 'José Altafini', imageUrl: null, fact: 'Brazilian-Italian footballer' },
  { name: 'Eike Immel', imageUrl: null, fact: 'German association football player' },
  { name: 'Amauri', imageUrl: null, fact: 'Italian Brazilian footballer' },
  {
    name: 'Pietro Anastasi',
    imageUrl: null,
    fact: 'Italian association football player (1948–2020)'
  },
  { name: 'Roberto Anzolin', imageUrl: null, fact: 'Italian footballer (1938–2017)' },
  { name: 'Werner Eilitz', imageUrl: null, fact: 'German association football player (1923-1995)' },
  {
    name: 'Gerhard Franke',
    imageUrl: null,
    fact: 'German association football player (1933-1997)'
  },
  { name: 'Horst Freitag', imageUrl: null, fact: 'German association football player (1930-2019)' },
  { name: 'Thomas Grether', imageUrl: null, fact: 'German association football player' },
  { name: 'Neto', imageUrl: null, fact: 'Brazilian association football player' },
  { name: 'Joachim Witt', imageUrl: null, fact: 'German rock musician' },
  { name: 'Leandro Damião', imageUrl: null, fact: 'Brazilian association football player' },
  { name: 'Hulk', imageUrl: null, fact: 'Brazilian association football player' },
  { name: 'Benjamin Lauth', imageUrl: null, fact: 'German association footballer' },
  { name: 'Mounir El Hamdaoui', imageUrl: null, fact: 'Moroccan footballer (born 1984)' },
  { name: 'Jens Keller', imageUrl: null, fact: 'German football player and manager' },
  { name: 'Kamil Glik', imageUrl: null, fact: 'Polish association football player' },
  { name: 'Rudi Gutendorf', imageUrl: null, fact: 'German football manager (1926-2019)' },
  { name: 'Tatiana Egorova', imageUrl: null, fact: 'Russian footballer (1970-2012)' },
  { name: 'Gabriel Heinze', imageUrl: null, fact: 'Argentine association football player' },
  { name: 'Arne Friedrich', imageUrl: null, fact: 'German association football player' },
  { name: 'Darko Lazović', imageUrl: null, fact: 'Serbian footballer (born 1990)' },
  {
    name: 'Serdar Taşçı',
    imageUrl: null,
    fact: 'Turkish-German association football player (born 1987)'
  },
  { name: 'Delron Buckley', imageUrl: null, fact: 'South African footballer' },
  { name: 'Bernd Heynemann', imageUrl: null, fact: 'German football referee' },
  { name: 'Manfred Burgsmüller', imageUrl: null, fact: 'German footballer (1949-2019)' },
  { name: 'Zoltán Varga', imageUrl: null, fact: 'Hungarian footballer (1945–2010)' },
  { name: 'Julio Tavares', imageUrl: null, fact: 'Cape Verdean association football player' },
  { name: 'Léon Semmeling', imageUrl: null, fact: 'Belgian footballer (1940-2024)' },
  { name: 'carlitos', imageUrl: null, fact: 'jugador profesional de padel' },
  { name: 'Vitinha', imageUrl: null, fact: 'Portuguese footballer (born 1986)' },
  { name: 'Aleksandre Chivadze', imageUrl: null, fact: 'Georgian footballer (born 1955)' },
  { name: 'Mamadou Diabang', imageUrl: null, fact: 'Senegalese footballer' },
  { name: 'Hermann Neuberger', imageUrl: null, fact: 'German football official (1919–1992)' },
  { name: 'Cristian Bonilla', imageUrl: null, fact: 'Colombian footballer' },
  { name: 'Tommaso Rocchi', imageUrl: null, fact: 'Italian association football player' },
  { name: 'Ádám Simon', imageUrl: null, fact: 'Hungarian football player' },
  {
    name: 'Nuri Şahin',
    imageUrl: null,
    fact: 'Turkish-German association football player (born 1988)'
  },
  { name: 'Andreas Müller', imageUrl: null, fact: 'German footballer (born 1962)' },
  { name: 'Ermin Bičakčić', imageUrl: null, fact: 'Bosnian association football player' },
  { name: 'Danny Schwarz', imageUrl: null, fact: 'German footballer (born 1975)' },
  { name: 'Ernst Lindner', imageUrl: null, fact: 'German footballer (1935–2012)' },
  { name: 'Diego Milito', imageUrl: null, fact: 'Argentine football player (1979-)' },
  { name: 'Nadine Keßler', imageUrl: null, fact: 'German soccer player' },
  { name: 'Ferdinand Biwersi', imageUrl: null, fact: 'German football referee (1934 - 2013)' },
  { name: 'Maik Taylor', imageUrl: null, fact: 'Northern Irish footballer (born 1971)' },
  { name: 'Christoph Daum', imageUrl: null, fact: 'German football manager (1953–2024)' },
  { name: 'Tim Borowski', imageUrl: null, fact: 'German footballer (born 1980)' },
  { name: 'Mohamed Zidan', imageUrl: null, fact: 'Egyptian association football player' },
  { name: 'Michihiro Yasuda', imageUrl: null, fact: 'Japanese association football player' },
  {
    name: 'Guido Buchwald',
    imageUrl: null,
    fact: 'German association football player and manager'
  },
  { name: 'Daniel Didavi', imageUrl: null, fact: 'German professional footballer' },
  { name: 'Lars Hirschfeld', imageUrl: null, fact: 'Canadian soccer player' },
  {
    name: 'Christian Tiffert',
    imageUrl: null,
    fact: 'German association football player and manager'
  },
  { name: 'Fatmire Alushi', imageUrl: null, fact: 'German association football player' },
  { name: 'Okan Aydın', imageUrl: null, fact: 'Turkish association football player (born 1994)' },
  {
    name: 'Benoît Assou-Ekotto',
    imageUrl: null,
    fact: 'Cameroonian-French footballer (born 1984)'
  },
  { name: 'Alexander Stolz', imageUrl: null, fact: 'German footballer (born 1983)' },
  { name: 'Ludwig Hofmann', imageUrl: null, fact: 'German footballer and manager (1900-1935)' },
  { name: 'Karsten Heine', imageUrl: null, fact: 'German footballer and manager' },
  { name: 'Werner Heine', imageUrl: null, fact: 'German footballer (1935–2022)' },
  { name: 'Gerhard Hanappi', imageUrl: null, fact: 'Austrian footballer (1929-1980)' },
  { name: 'Szabolcs Sáfár', imageUrl: null, fact: 'Hungarian association football player' },
  { name: 'Jörg Illing', imageUrl: null, fact: 'German association football player' },
  { name: 'Peter Kalinke', imageUrl: null, fact: 'German footballer (1936–2020)' },
  {
    name: 'Hans-Georg Kiupel',
    imageUrl: null,
    fact: 'German association football player (1934-2018)'
  },
  { name: 'Rudolf Krause', imageUrl: null, fact: 'German footballer and manager (1927-2003)' },
  { name: 'Günter Benkö', imageUrl: null, fact: 'Austrian football referee' },
  { name: 'Michael Langer', imageUrl: null, fact: 'Austrian association football player' },
  { name: 'István Avar', imageUrl: null, fact: 'Hungarian footballer (1905–1977)' },
  { name: 'Fernando Ariel Troyansky', imageUrl: null, fact: 'Argentine footballer' },
  {
    name: 'José Mourinho',
    imageUrl: null,
    fact: 'Portuguese association football manager and former player'
  },
  { name: 'Federico Marchetti', imageUrl: null, fact: 'Italian association football player' },
  { name: 'Mauro Zárate', imageUrl: null, fact: 'Argentine association football player' },
  { name: 'Robin Knoche', imageUrl: null, fact: 'German association football player' },
  {
    name: 'Giorgio Chiellini',
    imageUrl: null,
    fact: 'Italian sports executive and former association football player'
  },
  {
    name: 'Miroslav Klose',
    imageUrl: null,
    fact: 'German professional football manager and former player'
  },
  { name: 'Michael Keane', imageUrl: null, fact: 'English association football player, born 1993' },
  { name: 'Dante', imageUrl: null, fact: 'Brazilian association football player' },
  { name: 'Ever Palacios', imageUrl: null, fact: 'Colombian association football player' },
  { name: 'Isco', imageUrl: null, fact: 'Spanish association football player' },
  { name: 'Mano Menezes', imageUrl: null, fact: 'Brazilian football manager' },
  {
    name: 'Richie Wellens',
    imageUrl: null,
    fact: 'English association football player and manager (born 1980)'
  },
  { name: 'Anderson Bamba', imageUrl: null, fact: 'Brazilian association football player' },
  { name: 'Sonny Kittel', imageUrl: null, fact: 'German association football player' },
  { name: 'Robin Quaison', imageUrl: null, fact: 'Swedish association football player' },
  { name: 'Manuel De Sousa', imageUrl: null, fact: 'Portuguese football referee' },
  { name: 'Edwin García', imageUrl: null, fact: 'Colombian footballer' },
  {
    name: 'Aleksandr Vasilyev',
    imageUrl: null,
    fact: 'Russian association football player (born 1992)'
  },
  { name: 'David Villa', imageUrl: null, fact: 'Spanish association football player' },
  {
    name: 'Dani Carvajal',
    imageUrl: null,
    fact: 'Spanish association football player (born 1992)'
  },
  { name: 'Rubén Pardo', imageUrl: null, fact: 'Spanish soccer player' },
  { name: 'Asier Illarramendi', imageUrl: null, fact: 'Spanish association football player' },
  { name: 'Ricardo Cavalcante Mendes', imageUrl: null, fact: 'Brazilian footballer' },
  { name: 'Alfonso Montemayor', imageUrl: null, fact: 'Mexican footballer (1922-2012)' },
  { name: 'Christopher Oualembo', imageUrl: null, fact: 'Congolese footballer' },
  { name: 'Stephan Palla', imageUrl: null, fact: 'Association footballer' },
  { name: 'Svein Oddvar Moen', imageUrl: null, fact: 'Norwegian football referee' },
  {
    name: 'Sead Kolašinac',
    imageUrl: null,
    fact: 'Bosnian-German association football player (born 1993)'
  },
  { name: 'Sven Beuckert', imageUrl: null, fact: 'German association football player and manager' },
  { name: 'Wolfgang de Beer', imageUrl: null, fact: 'German footballer (1964–2024)' },
  { name: 'Ri Myong-jun', imageUrl: null, fact: 'North Korean footballer' },
  {
    name: 'Jasper Cillessen',
    imageUrl: null,
    fact: 'Dutch association football player (born 1989)'
  },
  {
    name: 'Steven Berghuis',
    imageUrl: null,
    fact: 'Dutch association football player (born 1991)'
  },
  { name: 'Diagné Fallou', imageUrl: null, fact: 'Senegalese and French footballer' },
  { name: 'Hidetoshi Nakata', imageUrl: null, fact: 'Japanese association football player' },
  {
    name: 'Derk Boerrigter',
    imageUrl: null,
    fact: 'Dutch association football player (born 1986)'
  },
  {
    name: 'Theo Bos',
    imageUrl: null,
    fact: 'association football manager and former player (1965-2013)'
  },
  {
    name: 'Hubert Fournier',
    imageUrl: null,
    fact: 'French association football manager and former player'
  },
  { name: 'Jean Fernandez', imageUrl: null, fact: 'French footballer and manager' },
  { name: 'Sallieu Bundu', imageUrl: null, fact: 'Sierra Leonean footballer' },
  { name: 'Frédéric Antonetti', imageUrl: null, fact: 'French football manager (born 1961)' },
  { name: 'Michael Owen', imageUrl: null, fact: 'English association football player' },
  {
    name: 'Toby Alderweireld',
    imageUrl: null,
    fact: 'Belgian association football player (born 1989)'
  },
  { name: 'Vegar Eggen Hedenstad', imageUrl: null, fact: 'Norwegian association football player' },
  { name: 'Lee Baxter', imageUrl: null, fact: 'Swedish association football player' },
  { name: 'Olivier Occéan', imageUrl: null, fact: 'Canadian association football player' },
  { name: 'Sebastian Freis', imageUrl: null, fact: 'German football player' },
  { name: 'Gaëtan Bong', imageUrl: null, fact: 'Cameroonian and French footballer' },
  { name: 'Thulani Serero', imageUrl: null, fact: 'South African association football player' },
  { name: 'Anthony Le Tallec', imageUrl: null, fact: 'French footballer (born 1984)' },
  { name: 'Claude Puel', imageUrl: null, fact: 'French football manager (born 1961)' },
  { name: 'Christian Gourcuff', imageUrl: null, fact: 'French football manager (born 1955)' },
  { name: 'Kenneth Vermeer', imageUrl: null, fact: 'Dutch association football player' },
  { name: 'Lorenzo Ebecilio', imageUrl: null, fact: 'Dutch association football player' },
  { name: 'Daley Blind', imageUrl: null, fact: 'Dutch association football player (born 1990)' },
  { name: 'Grégory Pujol', imageUrl: null, fact: 'French footballer (born 1980)' },
  { name: 'Kolbeinn Sigþórsson', imageUrl: null, fact: 'Icelandic footballer' },
  { name: 'Garra Dembélé', imageUrl: null, fact: 'Malian and French footballer' },
  { name: 'Max Kruse', imageUrl: null, fact: 'German association football player' },
  { name: 'Anton Putsila', imageUrl: null, fact: 'Belarusian association football player' },
  { name: 'Christophe Galtier', imageUrl: null, fact: 'French football manager (born 1966)' },
  { name: 'Paul Pogba', imageUrl: null, fact: 'French footballer (born 1993)' },
  { name: 'Özcan Arkoç', imageUrl: null, fact: 'Turkish association football player (1939–2021)' },
  { name: 'Timothy Chandler', imageUrl: null, fact: 'American soccer player' },
  { name: 'Jörg Berger', imageUrl: null, fact: 'German football player and coach (1944-2010)' },
  { name: 'Kerstin Stegemann', imageUrl: null, fact: 'German association football player' },
  { name: 'Holger Stanislawski', imageUrl: null, fact: 'footballer and football manager' },
  { name: 'Jürgen Röber', imageUrl: null, fact: 'German association football player and manager' },
  { name: 'Marco Kurz', imageUrl: null, fact: 'German football player and manager' },
  { name: 'Sönke Wortmann', imageUrl: null, fact: 'German film director' },
  { name: 'Klaus Sammer', imageUrl: null, fact: 'German footballer and manager' },
  { name: 'Franco Foda', imageUrl: null, fact: 'German association football player and manager' },
  {
    name: 'Daniel Bierofka',
    imageUrl: null,
    fact: 'German association football player and manager'
  },
  { name: 'Cédric Makiadi', imageUrl: null, fact: 'Congolese footballer' },
  { name: 'Julian Schuster', imageUrl: null, fact: 'German association football player' },
  { name: 'Jannik Vestergaard', imageUrl: null, fact: 'Danish association football player' },
  { name: 'Rudi Glöckner', imageUrl: null, fact: 'German football referee (1929–1999)' },
  { name: 'Hans-Jürgen Riediger', imageUrl: null, fact: 'German footballer (born 1955)' },
  { name: 'Eduard Geyer', imageUrl: null, fact: 'German football player and manager' },
  { name: 'Wolfgang Seguin', imageUrl: null, fact: 'East German footballer' },
  {
    name: 'Stephan Schröck',
    imageUrl: null,
    fact: 'Filipino association football player (born 1986)'
  },
  { name: 'Harald Irmscher', imageUrl: null, fact: 'East German footballer' },
  {
    name: 'Sercan Sararer',
    imageUrl: null,
    fact: 'Turkish association football player (born 1989)'
  },
  {
    name: 'Roberto Baggio',
    imageUrl: null,
    fact: 'Italian association football player (born 1967)'
  },
  { name: 'Oreste Barale', imageUrl: null, fact: 'Italian footballer (1904-1982)' },
  { name: 'Savino Bellini', imageUrl: null, fact: 'Italian footballer (1913-1974)' },
  { name: 'Luigi Bertolini', imageUrl: null, fact: 'Italian footballer (1904-1977)' },
  { name: 'Alberto Bertuccelli', imageUrl: null, fact: 'Italian footballer (1924-2002)' },
  { name: 'Carlo Bigatto', imageUrl: null, fact: 'Italian footballer (1895-1942)' },
  {
    name: 'Zbigniew Boniek',
    imageUrl: null,
    fact: 'Polish association football player and manager'
  },
  { name: 'Massimo Bonini', imageUrl: null, fact: 'Sammarinese footballer' },
  { name: 'Giampiero Boniperti', imageUrl: null, fact: 'Italian footballer (1928-2021)' },
  { name: 'Felice Borel', imageUrl: null, fact: 'Italian footballer (1914-1993)' },
  { name: 'Gianluigi Buffon', imageUrl: null, fact: 'former Italian footballer (born 1978)' },
  { name: 'Antonio Cabrini', imageUrl: null, fact: 'Italian footballer and manager' },
  { name: 'Umberto Caligaris', imageUrl: null, fact: 'Italian footballer (1901-1940)' },
  { name: 'Patrick Funk', imageUrl: null, fact: 'German professional footballer' },
  {
    name: 'Gernot Rohr',
    imageUrl: null,
    fact: 'German-French association football player and manager'
  },
  { name: 'Walter Eschweiler', imageUrl: null, fact: 'German football referee' },
  { name: 'Ehrenfried Patzel', imageUrl: null, fact: 'Czech footballer (1914-2004)' },
  { name: 'Klaus-Dieter Sieloff', imageUrl: null, fact: 'German footballer (1942–2011)' },
  {
    name: 'Wolfgang Rolff',
    imageUrl: null,
    fact: 'German association football player and manager'
  },
  { name: 'Mohd Faiz Subri', imageUrl: null, fact: 'Malaysian footballer' },
  { name: 'Rudi Hoffmann', imageUrl: null, fact: 'German footballer (1935–2020)' },
  { name: 'Friedrich Scherfke', imageUrl: null, fact: 'Polish footballer (1909-1983)' },
  { name: 'Manfred Zapf', imageUrl: null, fact: 'East German footballer' },
  { name: 'Raptile', imageUrl: null, fact: 'German singer and rapper' },
  { name: 'Phil Bardsley', imageUrl: null, fact: 'association football player (born 1985)' },
  { name: 'Per Mertesacker', imageUrl: null, fact: 'German association football player' },
  { name: 'Marcus Hahnemann', imageUrl: null, fact: 'American soccer player' },
  { name: 'David Pizarro', imageUrl: null, fact: 'Chilean footballer (born 1979)' },
  {
    name: 'Jack White',
    imageUrl: null,
    fact: 'German music producer and composer, association football player (1940–2025)'
  },
  { name: 'Christine Beck', imageUrl: null, fact: 'German football referee' },
  { name: 'Rafael Moreno Aranzadi', imageUrl: null, fact: 'Spanish footballer (1892–1922)' },
  { name: 'Adam Johnson', imageUrl: null, fact: 'English association football player (born 1987)' },
  { name: 'Hugo Betting', imageUrl: null, fact: 'German rugby union player (1880-1930)' },
  { name: 'Deniz Yılmaz', imageUrl: null, fact: 'Turkish association football player (born 1988)' },
  { name: 'Uğur İnceman', imageUrl: null, fact: 'Turkish association football player (born 1981)' },
  {
    name: 'Kurt Linder',
    imageUrl: null,
    fact: 'German association football player and manager (1933–2022)'
  },
  { name: 'Karlheinz Pflipsen', imageUrl: null, fact: 'German footballer and manager' },
  { name: 'Mateo Pavlović', imageUrl: null, fact: 'association footballer' },
  {
    name: 'Rui Pedro Couto Ramalho',
    imageUrl: null,
    fact: 'Portuguese professional footballer, born 1988'
  },
  { name: 'Marvin Plattenhardt', imageUrl: null, fact: 'German association football player' },
  { name: 'David Kipiani', imageUrl: null, fact: 'Georgian footballer (1951-2001)' },
  { name: 'Wilfried Gröbner', imageUrl: null, fact: 'East German footballer and manager' },
  { name: 'Lucas Digne', imageUrl: null, fact: 'French footballer (born 1993)' },
  { name: 'Georg Volkert', imageUrl: null, fact: 'German footballer (1945-2020)' },
  { name: 'Eliseu', imageUrl: null, fact: 'Portuguese association football player' },
  { name: 'Ricardinho', imageUrl: null, fact: 'Brazilian association football player and manager' },
  { name: 'Luiz Adriano', imageUrl: null, fact: 'Brazilian association footballer' },
  { name: 'Ralf', imageUrl: null, fact: 'Brazilian footballer' },
  { name: 'Jürgen Nöldner', imageUrl: null, fact: 'East German footballer (1941–2022)' },
  { name: 'Peter Neururer', imageUrl: null, fact: 'German association football manager' },
  {
    name: 'Peco Bauwens',
    imageUrl: null,
    fact: 'German football player and administrator (1886–1963)'
  },
  { name: 'Paulinho', imageUrl: null, fact: 'Brazilian footballer (born 1988)' },
  { name: 'Maurice Cook', imageUrl: null, fact: 'professional association footballer (1931-2006)' },
  { name: 'Francesco Totti', imageUrl: null, fact: 'Italian association football player' },
  { name: 'Alan Dzagoev', imageUrl: null, fact: 'Russian association football player' },
  { name: 'Fritz Walter', imageUrl: null, fact: 'German association football player (1920–2002)' },
  { name: 'Gaetano Monachello', imageUrl: null, fact: 'Italian footballer (born 1994)' },
  { name: 'Natalia Zinchenko', imageUrl: null, fact: 'former Ukrainian football player' },
  {
    name: 'Raúl Banfi',
    imageUrl: null,
    fact: 'Uruguayan professional football player (1914-1982)'
  },
  { name: 'Andrew Nabbout', imageUrl: null, fact: 'Australian association football player' },
  { name: 'Óscar Míguez', imageUrl: null, fact: 'Uruguayan footballer (1927-2006)' },
  { name: 'Mohamed Youssouf', imageUrl: null, fact: 'Comorian football defender' },
  { name: 'Björn Lindemann', imageUrl: null, fact: 'German football player' },
  { name: 'Milorad Mažić', imageUrl: null, fact: 'Serbian association football referee' },
  { name: 'Omar Arellano Nuño', imageUrl: null, fact: 'Mexican footballer (born 1967)' },
  { name: 'Volodymyr Shekhovtsov', imageUrl: null, fact: 'Ukrainian association footballer' },
  { name: 'Isabell Herlovsen', imageUrl: null, fact: 'Norwegian football player' },
  {
    name: 'Klaas-Jan Huntelaar',
    imageUrl: null,
    fact: 'Dutch association football player (born 1983)'
  },
  {
    name: 'Steven Caulker',
    imageUrl: null,
    fact: 'Sierra Leonean-English association football player'
  },
  { name: 'Roman Neustädter', imageUrl: null, fact: 'Russian professional footballer' },
  { name: 'Klemen Lavrič', imageUrl: null, fact: 'Slovenian association football player' },
  { name: 'Iago Aspas', imageUrl: null, fact: 'Spanish association football player' },
  { name: 'Luis Suárez', imageUrl: null, fact: 'Uruguayan association football player' },
  { name: 'Mbaye Niang', imageUrl: null, fact: 'Senegalese and French footballer' },
  {
    name: 'Abdullah Avcı',
    imageUrl: null,
    fact: 'Turkish association football player and coach (born 1963)'
  },
  {
    name: 'Álex Fernández',
    imageUrl: null,
    fact: 'Spanish footballer who plays for Real Madrid Castilla as a midfielder'
  },
  {
    name: 'Antonio Conte',
    imageUrl: null,
    fact: 'Italian association football player and manager'
  },
  { name: 'Kim Ju-song', imageUrl: null, fact: 'North Korean footballer' },
  { name: 'Florian Thauvin', imageUrl: null, fact: 'French footballer (born 1993)' },
  { name: 'Gaël Angoula', imageUrl: null, fact: 'French-Cameroonian football referee' },
  { name: 'Frédéric Hantz', imageUrl: null, fact: 'French football manager' },
  { name: 'Lucas Daniel Wilchez', imageUrl: null, fact: 'Argentinian footballer' },
  { name: 'Mehdi Mostefa', imageUrl: null, fact: 'Algerian and French footballer' },
  { name: 'Franco Zuculini', imageUrl: null, fact: 'Argentine footballer' },
  { name: 'Sambou Yatabaré', imageUrl: null, fact: 'Malian and French footballer' },
  { name: 'Sigamary Diarra', imageUrl: null, fact: 'Malian and French footballer' },
  { name: 'Jérôme Rothen', imageUrl: null, fact: 'French footballer (born 1978)' },
  {
    name: 'Emre Can',
    imageUrl: null,
    fact: 'Turkish-German association football player (born 1994)'
  },
  { name: 'Ádám Pintér', imageUrl: null, fact: 'association football player' },
  { name: 'Felipe Saad', imageUrl: null, fact: 'Brazilian footballer' },
  { name: 'Eduardo Ribeiro dos Santos', imageUrl: null, fact: 'Brazilian footballer' },
  { name: 'Álvaro Rubio', imageUrl: null, fact: 'Spanish football manager and former player' },
  { name: 'Johan Cavalli', imageUrl: null, fact: 'French footballer (born 1981)' },
  {
    name: 'Wahbi Khazri',
    imageUrl: null,
    fact: 'Tunisian-French association football player (born 1991)'
  },
  { name: 'Fousséni Diawara', imageUrl: null, fact: 'Malian and French footballer' },
  { name: 'Frédéric Sammaritano', imageUrl: null, fact: 'French association football player' },
  { name: 'Alex Dupont', imageUrl: null, fact: 'French football manager (1954-2020)' },
  { name: 'Ilan', imageUrl: null, fact: 'Brazilian footballer' },
  { name: 'Gaëtan Varenne', imageUrl: null, fact: 'French-Israeli association footballer' },
  { name: 'Landry Bonnefoi', imageUrl: null, fact: 'French footballer (born 1983)' },
  { name: 'Miguel Gordillo', imageUrl: null, fact: 'Cameroonian association football player' },
  { name: 'Jean Armel Kana Biyik', imageUrl: null, fact: 'Cameroonian and French footballer' },
  { name: 'Jonathan dos Santos', imageUrl: null, fact: 'Mexican association football player' },
  { name: 'Thiago Alcântara', imageUrl: null, fact: 'Spanish association football player' },
  {
    name: 'Cesc Fàbregas',
    imageUrl: null,
    fact: 'Spanish professional footballer player and manager'
  },
  {
    name: 'Xavi Hernández',
    imageUrl: null,
    fact: 'Spanish association football player and manager (born 1980)'
  },
  { name: 'Gerard Piqué', imageUrl: null, fact: 'Spanish association football player' },
  {
    name: 'Diego Maradona',
    imageUrl: null,
    fact: 'Argentine football player and manager (1960–2020)'
  },
  {
    name: 'Elie Wiesel',
    imageUrl: null,
    fact: 'Romanian-born American writer, professor, political activist, Nobel laureate, and Holocaust survivor (1928-2016)'
  },
  { name: 'Eniola Aluko', imageUrl: null, fact: 'English association football player (born 1987)' },
  {
    name: 'Rachel Williams',
    imageUrl: null,
    fact: 'English association football player (born 1988)'
  },
  { name: 'Toni Duggan', imageUrl: null, fact: 'English association football player (born 1991)' },
  { name: 'Faye White', imageUrl: null, fact: 'English association football player (born 1978)' },
  {
    name: 'Katie Chapman',
    imageUrl: null,
    fact: 'English association football player (born 1982)'
  },
  {
    name: 'Cristiano Ronaldo',
    imageUrl: null,
    fact: 'Portuguese association football player (born 1985) who play for al nassar fc'
  },
  { name: 'Raúl', imageUrl: null, fact: 'Spanish association football player' },
  { name: 'Iker Casillas', imageUrl: null, fact: 'Spanish association football player' },
  {
    name: 'Silvio Berlusconi',
    imageUrl: null,
    fact: 'Italian politician and media tycoon (1936–2023)'
  },
  { name: 'Tim Matavž', imageUrl: null, fact: 'Slovenian footballer' },
  { name: 'Orlando Engelaar', imageUrl: null, fact: 'Dutch footballer (born 1979)' },
  {
    name: 'Michael Ballack',
    imageUrl: null,
    fact: 'German association football player (born 1976)'
  },
  {
    name: 'Dick Advocaat',
    imageUrl: null,
    fact: 'Dutch association football player and manager (born 1947)'
  },
  {
    name: 'Dries Mertens',
    imageUrl: null,
    fact: 'Belgian association football player (born 1987)'
  },
  { name: 'Ola Toivonen', imageUrl: null, fact: 'Swedish footballer (born 1986)' },
  {
    name: 'Phillip Cocu',
    imageUrl: null,
    fact: 'Dutch association football player and manager (born 1970)'
  },
  { name: 'Bafétimbi Gomis', imageUrl: null, fact: 'French association football player' },
  { name: 'Rémi Garde', imageUrl: null, fact: 'French football manager (born 1966)' },
  { name: 'Pelé', imageUrl: null, fact: 'Brazilian footballer (1940–2022)' },
  {
    name: 'Stephan El Shaarawy',
    imageUrl: null,
    fact: 'Italian association football player (born 1992)'
  },
  {
    name: 'Paul Gascoigne',
    imageUrl: null,
    fact: 'English association football player and manager (born 1967)'
  },
  { name: 'Steed Malbranque', imageUrl: null, fact: 'French footballer (born 1980)' },
  { name: 'Rémy Vercoutre', imageUrl: null, fact: 'French footballer (born 1980)' },
  { name: 'Mouhamadou Dabo', imageUrl: null, fact: 'Senegalese and French footballer' },
  { name: 'Alexandre Lacazette', imageUrl: null, fact: 'French footballer (born 1991)' },
  { name: 'Samuel Umtiti', imageUrl: null, fact: 'French footballer (born 1993)' },
  { name: 'Grégory Coupet', imageUrl: null, fact: 'French footballer (born 1972)' },
  { name: 'Jean-Pierre Papin', imageUrl: null, fact: 'French football manager (born 1963)' },
  { name: 'Ri Kwang-chon', imageUrl: null, fact: 'North Korean footballer' },
  { name: 'Óscar Tabárez', imageUrl: null, fact: 'Uruguayan football manager and player' },
  {
    name: 'Jack Wilshere',
    imageUrl: null,
    fact: 'English association football player (born 1992)'
  },
  {
    name: 'Markus Weinzierl',
    imageUrl: null,
    fact: 'German association football player and manager'
  },
  { name: 'Daniel Passarella', imageUrl: null, fact: 'Argentine footballer (born 1953)' },
  { name: 'Carles Puyol', imageUrl: null, fact: 'Spanish association football player (born 1978)' },
  { name: 'Johan Cruyff', imageUrl: null, fact: 'Dutch footballer and manager (1947–2016)' },
  { name: 'Oleksandr Horyainov', imageUrl: null, fact: 'professional football goalkeeper' },
  {
    name: 'Burak Yılmaz',
    imageUrl: null,
    fact: 'Turkish association football player and manager (born 1985)'
  },
  { name: 'Aly Cissokho', imageUrl: null, fact: 'French association football player' },
  { name: 'Adrien Rabiot', imageUrl: null, fact: 'French footballer (born 1995)' },
  { name: 'Ole Gunnar Solskjær', imageUrl: null, fact: 'Norwegian association football manager' },
  { name: 'Tom Ince', imageUrl: null, fact: 'English association football player' },
  { name: 'Daniel González Güiza', imageUrl: null, fact: 'Spanish association football player' },
  { name: 'Mame Biram Diouf', imageUrl: null, fact: 'Senegalese association football player' },
  { name: 'Adam Miller', imageUrl: null, fact: 'association football midfielder (born 1982)' },
  { name: 'Alan Julian', imageUrl: null, fact: 'Association football goalkeeper (born 1983)' },
  { name: 'Karl Henry', imageUrl: null, fact: 'English professional footballer (born 1982)' },
  { name: 'Andrés Guardado', imageUrl: null, fact: 'Mexican association football player' },
  { name: 'Vicente Guaita', imageUrl: null, fact: 'Spanish association football player' },
  { name: 'Juan Bernat', imageUrl: null, fact: 'Spanish association football player' },
  { name: 'Dani Parejo', imageUrl: null, fact: 'Spanish association football player' },
  { name: 'Éver Banega', imageUrl: null, fact: 'Argentine association football player' },
  { name: 'Oscar', imageUrl: null, fact: 'Brazilian association football player (born 1991)' },
  { name: 'Andre de Kruijff', imageUrl: null, fact: 'Dutch footballer (1895-1964)' },
  { name: 'Yassine Benzia', imageUrl: null, fact: 'Algerian and French footballer' },
  { name: 'Jan de Kreek', imageUrl: null, fact: 'Dutch footballer (1903-1988)' },
  { name: 'Eugen Polanski', imageUrl: null, fact: 'Polish-German footballer' },
  { name: 'Caster Semenya', imageUrl: null, fact: 'South African middle-distance runner' },
  { name: 'Q7085', imageUrl: null, fact: 'Danish physicist (1885–1962)' },
  {
    name: 'Rainer Troppa',
    imageUrl: null,
    fact: 'German association football player and manager (1958-2023)'
  },
  { name: 'Jonathan Schmid', imageUrl: null, fact: 'French professional footballer' },
  { name: 'Mensur Mujdža', imageUrl: null, fact: 'Bosnian association football player' },
  {
    name: 'Daniel Sanchez',
    imageUrl: null,
    fact: 'French association football player and manager'
  },
  { name: 'Stefano Denswil', imageUrl: null, fact: 'Surinamese footballer' },
  { name: 'Joël Veltman', imageUrl: null, fact: 'Dutch association football player (born 1992)' },
  { name: 'Davy Klaassen', imageUrl: null, fact: 'Dutch association football player (born 1993)' },
  { name: 'Roly Bonevacia', imageUrl: null, fact: 'Dutch association football player' },
  {
    name: 'Matthias Ginter',
    imageUrl: null,
    fact: 'German association football player (born 1994)'
  },
  { name: 'Ada Hegerberg', imageUrl: null, fact: 'Norwegian footballer' },
  { name: 'Christian Streich', imageUrl: null, fact: 'German football player and manager' },
  { name: 'Luc Borrelli', imageUrl: null, fact: 'French footballer (1965-1999)' },
  { name: 'Marco Benassi', imageUrl: null, fact: 'Italian association football player' },
  { name: 'Peter Oskam', imageUrl: null, fact: 'Dutch former politician' },
  { name: 'Thomas Bickel', imageUrl: null, fact: 'Swiss association football player' },
  {
    name: 'Tony Leblanc',
    imageUrl: null,
    fact: 'Spanish actor, director, and comedian (1922-2012)'
  },
  { name: 'Diego Fagúndez', imageUrl: null, fact: 'Uruguayan footballer' },
  { name: 'Siebe Schrijvers', imageUrl: null, fact: 'Belgian association football player' },
  { name: 'Mario Balotelli', imageUrl: null, fact: 'Italian association football player' },
  { name: 'Kevin Volland', imageUrl: null, fact: 'German footballer (born 1992)' },
  { name: 'Manolo Gabbiadini', imageUrl: null, fact: 'Italian association football player' },
  { name: 'Sandy Walsh', imageUrl: null, fact: 'Indonesian footballer' },
  { name: 'Takuji Yonemoto', imageUrl: null, fact: 'Japanese association football player' },
  {
    name: 'Pablo Aimar',
    imageUrl: null,
    fact: 'Argentine association football manager (born 1979)'
  },
  { name: 'Eric Hassli', imageUrl: null, fact: 'French footballer (born 1981)' },
  { name: 'Choe Myong-Ho', imageUrl: null, fact: 'North Korean footballer' },
  { name: 'Mark Owen', imageUrl: null, fact: 'English singer-songwriter (born 1972)' },
  { name: 'Antonio Bocchetti', imageUrl: null, fact: 'Italian footballer born 1980' },
  { name: 'Toni Kroos', imageUrl: null, fact: 'German former football player' },
  { name: 'Oliver Kahn', imageUrl: null, fact: 'German association football player (born 1969)' },
  {
    name: 'Dieter Hecking',
    imageUrl: null,
    fact: 'German association football player and manager'
  },
  { name: 'Willy Tröger', imageUrl: null, fact: 'German association football player (1928-2004)' },
  {
    name: 'Thibaut Courtois',
    imageUrl: null,
    fact: 'Belgian association football player (born 1992)'
  },
  { name: 'Willian', imageUrl: null, fact: 'Brazilian association football player' },
  { name: 'Bianca Schmidt', imageUrl: null, fact: 'German association football player' },
  {
    name: 'Simon Lappin',
    imageUrl: null,
    fact: 'Scottish association football player (born 1983)'
  },
  { name: 'Jürgen Sundermann', imageUrl: null, fact: 'German footballer and manager (1940–2022)' },
  { name: 'Viktor Fischer', imageUrl: null, fact: 'Danish association football player' },
  { name: 'James Morrison', imageUrl: null, fact: 'association football player' },
  { name: 'Wilson Kamavuaka', imageUrl: null, fact: 'Congolese footballer' },
  { name: 'Carlos Valdés', imageUrl: null, fact: 'Colombian footballer' }
]
